export const isRequired = (fieldName: string) => {
  return `${fieldName} is required`;
};

export const mustMatch = (otherFieldName: string) => {
  return (fieldName) => `${fieldName} must match ${otherFieldName}`;
};

export const minLength = (length: number) => {
  return (fieldName) => `${fieldName} must be at least ${length} characters`;
};

export const maxAllowedLength = (length: number) => {
  return (fieldName) =>
    `Maximum length for ${fieldName} is ${length} characters`;
};

export const isValidAmount = (fieldName: string) => {
  return `Enter a valid ${fieldName} `;
};

export const isValidPercent = (fieldName: string) => {
  return `Enter a valid ${fieldName} `;
};

export const isValidYear = (fieldName: string) => {
  return `Enter a valid ${fieldName} `;
};

export const isValidAge = (fieldName: string) => {
  return `Enter a valid ${fieldName} `;
};

export const isValidEmail = (fieldName: string) => {
  return `Enter a valid ${fieldName} `;
};

export const isValidFlatFee = (fieldName: string) => {
  return `Enter a valid ${fieldName} `;
};

export const resetValidationMessage = () => {
  return '';
};

export const isValidPortfolioFee = () => {
  return 'Enter a valid fee.';
};

export const isValidInvestmentMonthlyContribution = () => {
  return 'Investment amount must be greater than 0';
};
